<template>

    <div>
        <loading />
        <header-cna />
        <router-view />
        <footer-cna />

    </div>

</template>
<script>

    import footerCna from '@/template/footer'
    import headerCna from '@/template/header'
    import loading from '@/common/components/loading'

    export default {
        name: "Template",
        components: { footerCna, headerCna, loading },
        data() {
            return {

            };
        },
        mounted() {
           
        },
        beforeDestroy() {
        },
    };


</script>
